import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(client)/supply-chain-mapping/(pages)/(list)',
)({
  component: lazyRouteComponent(
    () => import('../../-components/SupplyChainMappingLayout'),
    'SupplyChainMappingLayout',
  ),
});
